import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import InviteSignupForm from "./InviteSignupForm";
import { LoadingSpinner } from "@/components/ui/atoms/loading-spinner";
import { useToken } from "@/hooks/useToken";

const RegisterMember: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      navigate(`/register/info?token=${encodeURIComponent(token)}`, {
        replace: true,
      });
    } else {
      // fallback: no token, go to generic info page or home
      navigate("/register/info", { replace: true });
    }
  }, [searchParams, navigate]);
  return null;
};

export default RegisterMember;
